import * as React from "react";

const ChevronDropDownIcon = ({ fillColor = "#190A28", ...props }) => (
	// eslint-disable-next-line react/jsx-props-no-spreading
	<svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
		<path
			fill={fillColor}
			d="M10.587 6.193 8 8.78 5.413 6.193a.664.664 0 1 0-.94.94l3.06 3.06c.26.26.68.26.94 0l3.06-3.06c.26-.26.26-.68 0-.94a.678.678 0 0 0-.946 0Z"
		/>
	</svg>
);
export default ChevronDropDownIcon;
